import { AccountCowboyHatOutlineIcon } from './AccountCowboyHatOutlineIcon';

/**
 * author: Jeff Anders
 * id E1C851E1-3BBD-4661-A6FA-C77AD370DC6A
 * name account-cowboy-hat-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-cowboy-hat-outline.svg
 * tags
 * - Account / User 
 * - Agriculture 
 */
export const RancherOutlineIcon = AccountCowboyHatOutlineIcon;
export default RancherOutlineIcon